export const STORAGE_KEYS = {
  AUTH_TOKEN: 'authToken',
  ID_TOKEN: 'idToken',
  REFRESH_TOKEN: 'refreshToken',
  USER: 'user',
  SIDEBAR_COLLAPSED: 'sidebarCollapsed',
} as const;

export const API_CONFIG = {
  TIMEOUT_MS: 30_001,
  DEFAULT_REGION: 'ap-southeast-2',
} as const;

export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 20,
} as const;

export const AUTH_CONFIG = {
  CHECK_INTERVAL_MS: 60_000,
  DEFAULT_USER_EMAIL: 'user@secureembed.local',
} as const;
